/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { KTSVG } from '../../../../_metronic/helpers';
import CycleMarker from '../../../components/CycleMarker';
import DateValue from '../../../components/DateValue';
import DivideValue from '../../../components/DivideValue';
import PickerValue from '../../../components/PickerValue';
var XMLParser = require('react-xml-parser');

const TableItem = (props: any) => {
    const { indexing, headers, data, handleNext, definitions, serverStatus, handleDelete } = props;
    const [odd, setOdd] = useState<boolean>(false);
    const [background, setBackground] = useState<string>("");
    const intl = useIntl()

    useEffect(() => {
        if (indexing % 2 === 0) {
            setOdd(true)
        } else {
            setOdd(false)
        }
    }, [indexing])

    const handleClick = () => {
        handleNext(data.id);
    }

    const handledelete = () => {
        // @ts-ignore
        Swal.fire({
            text: intl.formatMessage({ id: 'SEARCH.WOULD.DELETE.COMPANY.PREFIX' }) + '"' + data.description + '"' + intl.formatMessage({ id: 'SEARCH.WOULD.DELETE.COMPANY.SUBFIX' }),
            icon: "warning",
            showCancelButton: true,
            buttonsStyling: false,
            confirmButtonText: intl.formatMessage({ id: 'SEARCH.DELETE' }),
            cancelButtonText: intl.formatMessage({ id: 'SEARCH.CANCEL' }),
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-active-light"
            }
        }).then(async function (result: any) {
            if (result.value) {
                handleDelete(data.id);
            } else if (result.dismiss === 'cancel') {

            }
        });
    }

    useEffect(() => {
        if (data['projectstatus']) {
            switch (data['projectstatus']) {
                case 'Good':
                    // setBackground("bg-light-success");
                    if (odd) {
                        setBackground("bg-gray-100 text-gray-800");
                    } else {
                        setBackground("text-gray-800")
                    }
                    break;
                case 'To Do':
                    setBackground("bg-light-warning");
                    break;
                case 'Critical':
                    setBackground("bg-light-danger");
                    break;
                case 'Waiting':
                    setBackground("bg-light-primary");
                    break;

                default:
                    break;
            }
        } else {
            if (odd) {
                setBackground("bg-gray-100 text-gray-800");
            } else {
                setBackground("text-gray-800")
            }
        }
        // eslint-disable-next-line
    }, [data])

    return (
        <tr className={background}>
            {
                headers.map((item: any, index: number) => {
                    const definition = definitions[index].definition;
                    // const option = options[index]
                    const xml = new XMLParser().parseFromString(definition);
                    const filter = xml.children.filter((item: any) => item.name === 'objecttype')
                    let objectType = "";
                    if (filter[0]) {
                        objectType = filter[0].value;
                    } else {
                        // console.log("Not fount objectType => ", xml);
                    }
                    if (objectType === 'picker') {
                        return (
                            <PickerValue
                                key={index}
                                header={item.toLowerCase()}
                                datas={data[item.toLowerCase()]}
                                handleClick={handleClick}
                                definition={xml.children}
                            />
                        )
                    }
                    else if (objectType === 'date') {
                        return (
                            <DateValue
                                key={index}
                                header={item.toLowerCase()}
                                datas={data[item.toLowerCase()]}
                                handleClick={handleClick}
                                definition={xml.children}
                            />
                        )
                    }
                    else if (objectType === 'checkbox') {
                        return (
                            <td style={{ padding: '0px 10px' }} onClick={handleClick} key={index}>
                                <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                    <input
                                        className='form-check-input widget-9-check'
                                        type='checkbox'
                                        style={{ borderRadius: '3px' }}
                                        readOnly={true}
                                        checked={data[item.toLowerCase()]}
                                    />
                                </div>
                            </td>
                        )
                    }
                    else if (objectType === 'divide') {
                        return (
                            <DivideValue
                                key={index}
                                data={data}
                                handleClick={handleClick}
                            />
                        )
                    }
                    else if (objectType === 'cyclemarker') {
                        return (
                            <CycleMarker
                                key={index}
                                data={data}
                                handleClick={handleClick}
                                serverStatus={serverStatus}
                            />
                        )
                    }
                    else {
                        return (
                            <td key={index} style={{ padding: '0px 10px', overflow: 'hidden', height: 40, }}
                                onClick={handleClick}
                            >
                                <a className='text-dark  text-hover-primary d-block ' style={{ cursor: 'pointer', wordBreak: 'break-all', maxHeight: 40, fontWeight: 100, fontSize: '13px', }}>
                                    {data[item.toLowerCase()]}
                                </a>
                            </td>
                        )
                    }
                })
            }
            <td style={{ width: '100%', height: 40, minWidth: '40px', padding: '0px 5px 0px 5px ' }}>
                <div className='d-flex justify-content-center'>
                    <button
                        className={`btn btn-icon btn-bg-light btn-active-color-danger btn-sm`}
                        style={{ width: "30px", height: "30px" }}
                        data-bs-toggle="modal" data-bs-target="#delete-one-confirm-modal"
                        onClick={handledelete}
                    >
                        <KTSVG
                            path='/media/icons/duotune/general/gen027.svg'
                            className='svg-icon-2'
                        />
                    </button>
                </div>
            </td>
        </tr >
    )
}

export default TableItem;